<div class="flexie-auto-grid m-t-b-60">

  <div class="flex-self-vert-start">
    <div *ngIf="addressList && addressList.length < 1">
      <div class="zero-ui">
        <i nz-icon nzType="schedule" nzTheme="outline"></i>
        <h2 translate>Add Address</h2>
        <p translate>You need to at-least one address to continue</p>
      </div>
    </div>
    <div *ngIf="addressList && addressList.length > 0">
      <h3 translate> Addresses</h3>

      <div *ngFor="let item of addressList; let i = index;"
        class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center b-b-1 p-10">
        <div>

          <label nz-checkbox nz-tooltip [nzTitle]="'Mark as preferred'" [(ngModel)]="item.prefferedFl"
            (ngModelChange)="deselectOtherAddresssesPrefferedFl(i)"></label>&nbsp;
          <strong>{{item.typeCd || '' }}</strong>
          <br>
          {{item.addressLine1 || '' }}, {{item.addressLine2 || '' }}, {{item.addressLine3 || '' }}
          <br>
          {{(item.cityCd | technicalTranslate) || '' }}, {{(item.stateCd | technicalTranslate) || '' }}
          <br>
          {{(item.countryCd | technicalTranslate) || '' }}, {{item.postCode || '' }}
        </div>
        <div>
          <a href="javascript:void(0)" (click)="editAddress(item,i)">Edit</a> |
          <a href="javascript:void(0)" (click)="removeAddress(item,i)">Remove</a>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-self-vert-start" style="align-self: flex-start;">
    <div class="form-secondary">
      <h3 class="form-secondary-heading" translate>+ Add Address</h3>
      <form [formGroup]="uiAddressThaiForm" class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item>
          <nz-form-label nzFor="typeCd" [nzSpan]="24" [nzRequired]="isRequired('typeCd')"><span translate>Type</span>
          </nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch id="typeCd" formControlName="typeCd" style="width: 100%">
              <nz-option
                *ngFor="let item of (lookup$.addressTypeCd | async) as addressTypeCdLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
            <!--  -->
            <nz-form-explain
              *ngIf="(uiAddressThaiForm.get('typeCd').dirty || uiAddressThaiForm.get('typeCd').touched) && uiAddressThaiForm.get('typeCd').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('typeCd'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24"><span translate>Address Line 1, 2, 3</span></nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="{{'Address Line 1' | translate}}" formControlName="addressLine1" />
            <nz-form-explain
              *ngIf="(uiAddressThaiForm.get('addressLine1').dirty || uiAddressThaiForm.get('addressLine1').touched) && uiAddressThaiForm.get('addressLine1').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="{{'Address Line 2' | translate}}" formControlName="addressLine2" />
            <nz-form-explain
              *ngIf="(uiAddressThaiForm.get('addressLine2').dirty || uiAddressThaiForm.get('addressLine2').touched) && uiAddressThaiForm.get('addressLine2').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('addressLine2'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>

          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="{{'Address Line 3' | translate}}" formControlName="addressLine3" />
            <nz-form-explain
              *ngIf="(uiAddressThaiForm.get('addressLine3').dirty || uiAddressThaiForm.get('addressLine3').touched) && uiAddressThaiForm.get('addressLine3').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('addressLine3'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <div class="flexie-auto-grid p-b-10">
          <div>
            <label nz-checkbox formControlName="enableSearchByPinCode" (ngModelChange)="enableDisableSearchByPin()">
              Enable search by pincode</label>
          </div>
        </div>
        <!-- 3 -->
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24"><span translate>PIN Code</span></nz-form-label>
              <nz-form-control [nzSpan]="24">
                <!-- <input nz-input placeholder="Pin Code" formControlName="postCode" /> -->
                <ng-container *ngIf="uiAddressThaiForm.value.enableSearchByPinCode">
                  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input nz-input formControlName="postCode" />
                  </nz-input-group>
                </ng-container>

                <ng-container *ngIf="!uiAddressThaiForm.value.enableSearchByPinCode">
                  <input nz-input formControlName="postCode" />
                </ng-container>



                <ng-template #suffixIconButton>
                  <button (click)="fetchProvinceandCityByPostCode()" nz-button nzType="primary" class="d-b w-100-pc"><i
                      nz-icon type="search"></i></button>
                </ng-template>


                <nz-form-explain
                  *ngIf="(uiAddressThaiForm.get('postCode').dirty || uiAddressThaiForm.get('postCode').touched) && uiAddressThaiForm.get('postCode').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('postCode'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label nzFor="country" [nzSpan]="24" [nzRequired]="isRequired('countryCd')"><span
                  translate>Country</span>
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch id="country" formControlName="countryCd" style="width: 100%"
                  [class.inputs-are-disabled]="!disableDefaultCountryOnly" [nzDisabled]="!disableDefaultCountryOnly">
                  <nz-option
                    *ngFor="let item of (lookup$.countryCd | async) as countryCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(uiAddressThaiForm.get('countryCd').dirty || uiAddressThaiForm.get('countryCd').touched) && uiAddressThaiForm.get('countryCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('countryCd'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label nzFor="stateCd" [nzSpan]="24" [nzRequired]="isRequired('stateCd')"><span
                  translate>Province</span></nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch id="stateCd" [nzDisabled]="uiAddressThaiForm.value.enableSearchByPinCode"
                  formControlName="stateCd" (ngModelChange)="provinceSelected()" style="width: 100%">
                  <nz-option *ngFor="let item of (lookup$.stateCd | async) as stateCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(uiAddressThaiForm.get('stateCd').dirty || uiAddressThaiForm.get('stateCd').touched) && uiAddressThaiForm.get('stateCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('stateCd'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label nzFor="cityCd" [nzSpan]="24" [nzRequired]="isRequired('cityCd')"><span
                  translate>District</span></nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch id="cityCd" [nzDisabled]="uiAddressThaiForm.value.enableSearchByPinCode"
                  formControlName="cityCd" style="width: 100%">
                  <nz-option *ngFor="let item of (cityCd$ | async) as eventTypeCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.cityName" [nzValue]="item?.cityCd"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(uiAddressThaiForm.get('cityCd').dirty || uiAddressThaiForm.get('cityCd').touched) && uiAddressThaiForm.get('cityCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressThaiForm.get('cityCd'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>


      <div class="footer-actions-bar">
        <div>
          <!-- Left -->
        </div>
        <div>
          <!-- Right -->
          <button nz-button class="b-0 m-r-10" (click)="clearForm()"><span translate>Clear</span></button>
          <button nz-button [nzType]="'primary'" (click)="addAddress()"><span translate>Add</span></button>
        </div>
      </div>
    </div>
  </div>

</div>